import { useEffect, useMemo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import TimelineDrawer from "@/pages/Drawer/CustomerDrawer/TimelineDrawer";
import type { RootState } from "@/store/rootReducer";
import { useAppDispatch } from "@/store/hooks";
import { getStatusList } from "@/store/slices/customerSlice";
import { getVisitPurposes } from "@/store/slices/dealAndPipelineSlice";

const TeamActivityLeadPage = () => {
  const { leadId: leadIdParam } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const leadId = useMemo(() => Number(leadIdParam), [leadIdParam]);
  const leadName =
    (location.state as { leadName?: string } | undefined)?.leadName ?? "";

  const { statusList } = useSelector((s: RootState) => s.customer);
  const { visitPurpose } = useSelector((s: RootState) => s.deal);

  useEffect(() => {
    if (!Number.isFinite(leadId) || leadId <= 0) {
      navigate("/dashboard360", { replace: true });
    }
  }, [leadId, navigate]);

  useEffect(() => {
    if (!Array.isArray(statusList) || statusList.length === 0) {
      dispatch(getStatusList());
    }
  }, [dispatch, statusList]);

  useEffect(() => {
    if (!Array.isArray(visitPurpose) || visitPurpose.length === 0) {
      dispatch(getVisitPurposes());
    }
  }, [dispatch, visitPurpose]);

  if (!Number.isFinite(leadId) || leadId <= 0) {
    return null;
  }

  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: 2,
        p: 1,
        minHeight: "calc(100vh - 120px)",
      }}
    >
      <TimelineDrawer
        statusList={statusList}
        visitPurposeList={visitPurpose}
        leadId={leadId}
        leadName={leadName || "—"}
        oppNumber={0}
        type="Customer"
        hideHeader
      />
    </Box>
  );
};

export default TeamActivityLeadPage;
